require("core-js/modules/es6.regexp.split");

module.exports = function (n) {
  var r = !String(n).split(".")[1];
  return 1 == n && r ? "one" : "other";
};